import { Card, Tag, Button, Select, Row, Col, TableProps, Table, Pagination, Form, DatePicker, InputNumber, Space, Descriptions, Divider } from 'antd';
import { SearchOutlined, UndoOutlined } from "@ant-design/icons";
import React, { useCallback, useEffect, useState } from 'react';
import { apiGetCheckBalance, apiGetListAccountStatementPostpaid, apiGetListPartner, apiGetWalletBalanceTopUpCurrent } from '../../api';
import { PartnerList } from '../../interfaces/list-partner.interface';
import { formatCurrency, formatNumber } from '../../utils/string-utils';
import TopUpBalanceDeposit from '../../components/modals/TopUpBalanceDeposit';
import PaymentRevenueForPartner from '../../components/modals/PaymentRevenueForPartner';
import RefundForPartner from '../../components/modals/RefundForPartner';
import { useLoading } from '../../context/LoadingContext';
import moment from 'moment';
import dayjs from 'dayjs';
import defaultParams from '../../assets/constants/default_params';
import { mapCompanyAccounts } from '../../assets/constants/constants';

const initCusgomer = {
    partners: [],
    total: 0
}

export default function PartnerManagement() {
    const [customers, setCustomers] = useState<PartnerList>(initCusgomer)
    const [selectedCustomer, setSelectedCustomer] = useState<Number>(0);
    const [balance, setBalnace] = useState<Number>(0);
    const [balanceRefund, setBalnaceRefund] = useState<Number>(0);
    const [balanceRevenue, setBalnaceRevenue] = useState<Number>(0);
    const [activityHistory, setActivityHistory] = useState<any>({});
    const [cpCode, setCpCode] = useState<string>('');
    const [currentPage, setCurrentPage] = useState(defaultParams.PAGE);
    const [pageSize, setPageSize] = useState(defaultParams.LIMIT);
    const [search, setSearch] = useState<any>({})
    const [isOpenDeposit, setIsOpenDeposit] = useState(false);
    const [isOpenPaymentRevenue, setIsOpenPaymentRevenue] = useState(false);
    const [isOpenRefundForPartner, setIsOpenRefundForPartner] = useState(false);

    const { setIsLoading } = useLoading();
    const [formSearch] = Form.useForm()

    const status = 'Hoạt động';

    useEffect(() => {
        fetchApiGetListPartner()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (customers?.partners?.length > 0) {
            (async () => {
                setIsLoading(true)
                await fetchBalance()
                await fetchBalanceRefund()
                await fetchBalanceRevenue()
                setIsLoading(false)
            })()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customers, selectedCustomer])

    const fetchApiGetListPartner = useCallback(async () => {
        try {
            setIsLoading(true)
            const resCustomers = await apiGetListPartner()
            if (resCustomers.data.partners != null) {
                resCustomers.data.partners = resCustomers.data.partners.filter((item: any) => !mapCompanyAccounts[item.cpCode])
                setCustomers(resCustomers.data)
            } else {
                setCustomers(initCusgomer)
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            console.log(error)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    async function fetchBalance() {
        try {
            const cpCode = customers.partners[Number(selectedCustomer)]?.cpCode ?? '';
            setCpCode(cpCode)
            const BalanceTopUpCurrent = await apiGetWalletBalanceTopUpCurrent({ cpCode: cpCode });
            if (BalanceTopUpCurrent?.data?.balance != null) {
                setBalnace(BalanceTopUpCurrent.data.balance)
            } else {
                setBalnace(0)
            }
        } catch (error) {
            console.log(error);
            setBalnace(0)
        }
    }

    async function fetchBalanceRefund() {
        try {
            const cpCode = customers.partners[Number(selectedCustomer)]?.cpCode ?? '';
            const BalanceRefund = await apiGetCheckBalance({ cpCode: `${cpCode}_refund` });
            if (BalanceRefund?.data?.balance != null) {
                setBalnaceRefund(BalanceRefund?.data?.balance)
            } else {
                setBalnaceRefund(0)
            }
        } catch (error) {
            console.log(error);
            setBalnaceRefund(0)
        }
    }

    async function fetchBalanceRevenue() {
        try {
            const cpCode = customers.partners[Number(selectedCustomer)]?.cpCode ?? '';
            const BalanceRevenue = await apiGetCheckBalance({ cpCode: cpCode });
            if (BalanceRevenue?.data?.balance != null) {
                setBalnaceRevenue(Math.abs(BalanceRevenue.data.balance))
            } else {
                setBalnaceRevenue(0)
            }
        } catch (error) {
            console.log(error);
            setBalnaceRevenue(0)
        }
    }

    const fetchActivityHistory = useCallback(async () => {
        try {
            if (customers?.partners?.length <= 0) return
            setIsLoading(true)
            const cpCode = customers.partners[Number(selectedCustomer)]?.cpCode ?? ''
            const { data } = await apiGetListAccountStatementPostpaid({
                cpCode: cpCode,
                page: currentPage,
                size: pageSize,
                year: search.year,
                month: search.month,
                day: search.day,
            })
            setActivityHistory(data)
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    }, [customers, selectedCustomer, currentPage, pageSize, search])

    useEffect(() => {
        fetchActivityHistory()
    }, [fetchActivityHistory])

    const activityHistoryColumns: TableProps<any>['columns'] = [
        {
            key: 'createdAt',
            title: "Thời gian",
            dataIndex: 'createdAt',
            render: (value: any) => moment(value).format('DD/MM/YYYY HH:mm:ss'),
        },
        {
            key: 'cpCode',
            title: "Mã công ty",
            render: () => customers.partners[Number(selectedCustomer)]?.cpCode ?? '',
        },
        {
            key: 'type',
            title: "Loại giao dịch",
            dataIndex: 'type',
            render: (value: any) => {
                switch (value) {
                    case 2:
                        return <Tag color='green'>Nạp tiền</Tag>
                    case 3:
                        return <Tag color='red'>Thanh toán</Tag>
                    default:
                        return value
                }
            }
        },
        {
            key: 'price',
            title: "Số tiền",
            render: (_, data: any) => {
                switch (data.type) {
                    case 2:
                        return formatCurrency(data.credit)
                    case 3:
                        return formatCurrency(data.debit)
                    default:
                        return ''
                }
            }
        },
        {
            key: 'status',
            title: "Trạng thái",
            render: () => <Tag color='orange'>Hoàn thành</Tag>,
        },
        {
            key: 'description',
            title: "Mô tả",
            dataIndex: 'description',
        },
    ]

    const closeDeposit = async (requireSync?: boolean) => {
        setIsOpenDeposit(false)
        if (requireSync) {
            await fetchBalance()
            fetchActivityHistory()
        }
    }
    const closePaymentRevenue = async (requireSync?: boolean) => {
        setIsOpenPaymentRevenue(false)
        if (requireSync) {
            await fetchBalanceRevenue()
            fetchActivityHistory()
        }
    }
    const closeRefundForPartner = async (requireSync?: boolean) => {
        setIsOpenRefundForPartner(false)
        if (requireSync) {
            await fetchBalanceRefund()
        }
    }

    const depositEvent = () => setIsOpenDeposit(true)
    const revenuePaymentEvent = () => setIsOpenPaymentRevenue(true)
    const refundToPartners = () => setIsOpenRefundForPartner(true)

    const formatMoney = (money: Number) => money === 0 ? "N/A" : formatCurrency(Number(money));

    const handleSearch = (values: any) => {
        const date = dayjs(values.date)
        setSearch({
            year: date?.year(),
            month: date?.month() + 1,
            day: values.day || null,
        })
    }

    const handleClearSearch = () => {
        formSearch.resetFields()
        setSearch({})
    }

    return (<div style={{ display: 'flex' }}>
        <TopUpBalanceDeposit
            isModalVisible={isOpenDeposit}
            onClose={closeDeposit}
            cpCode={cpCode ?? ''}
        />
        <PaymentRevenueForPartner
            isModalVisible={isOpenPaymentRevenue}
            onClose={closePaymentRevenue}
            cpCode={cpCode ?? ''}
        />
        <RefundForPartner
            isModalVisible={isOpenRefundForPartner}
            onClose={closeRefundForPartner}
            cpCode={cpCode ?? ''}
        />
        <div style={{ flex: 1 }}>
            {customers?.partners.length > 0 && (
                <div>
                    <b>Chọn đối tác: </b> <Select
                        showSearch
                        style={{ flex: 1, marginBottom: 16, marginLeft: 8, width: 200 }}
                        placeholder="Chọn khách hàng"
                        optionFilterProp="name"
                        defaultValue={selectedCustomer}
                        onChange={(value) => setSelectedCustomer(value)}
                        filterOption={(input: any, option: any) =>
                            option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {customers?.partners?.map((customer: any, idx: React.Key) => (
                            <Select.Option key={idx} value={idx}>
                                {customer.name}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            )}
            <Card title={`Ví tiền: ${customers?.partners?.[Number(selectedCustomer)]?.displayName ?? ''}`}>
                <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                    <div style={{ flex: 1 }}>
                        <Row gutter={16}>
                            <Col span={8}>
                                <Card title="Số dư">
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <p style={{ fontSize: 16, fontWeight: 'bold' }}>{formatMoney(balance)}</p>
                                    </div>
                                </Card>
                            </Col>
                            <Col span={8}>
                                <Card title="Doanh thu">
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <p style={{ fontSize: 16, fontWeight: 'bold' }}>{formatMoney(balanceRevenue)}</p>
                                    </div>
                                </Card>
                            </Col>
                            <Col span={8}>
                                <Card title="Số tiền refund trong tháng">
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <p style={{ fontSize: 16, fontWeight: 'bold' }}>{formatMoney(balanceRefund)}</p>
                                    </div>
                                </Card>
                            </Col>


                        </Row>
                        <Row gutter={16} style={{ marginTop: 10, height: '100%' }}>

                        </Row>
                    </div>
                    <div style={{ width: 200, margin: '0 30px' }}>
                        <div style={{ marginBottom: 10 }}>
                            Trạng thái: <Tag color={status === 'Hoạt động' ? 'green' : 'red'}>{status}</Tag>
                        </div>
                        <Button type="primary" block style={{ marginBottom: 16 }} onClick={depositEvent}>Nạp tiền</Button>
                        <Button type="dashed" block style={{ marginBottom: 16 }} onClick={revenuePaymentEvent}>Thanh toán doanh thu</Button>
                        <Button type="link" block onClick={refundToPartners}>Hoàn tiền cho đối tác</Button>
                    </div>
                </div>
            </Card>
            <Card title="Lịch sử hoạt động" style={{ marginTop: 10 }}>
                <Form form={formSearch} onFinish={handleSearch} layout='horizontal'>
                    <div style={{ display: 'flex', alignItems: 'start', flexWrap: 'wrap', gap: 20 }}>
                        <Form.Item name="date" label="Tháng">
                            <DatePicker
                                format="YYYY-MM"
                                picker="month"
                            />
                        </Form.Item>
                        <Form.Item name="day" label="Ngày">
                            <InputNumber min={1} max={31} />
                        </Form.Item>
                        <Space style={{ marginBottom: 24 }}>
                            <Button type='primary' htmlType="submit" icon={<SearchOutlined />}>Tìm kiếm</Button>
                            <Button onClick={handleClearSearch} icon={<UndoOutlined />}></Button>
                        </Space>
                    </div>
                </Form>
                <Table
                    rowKey={(_, index: any) => index}
                    style={{ overflow: 'auto' }}
                    columns={activityHistoryColumns}
                    dataSource={activityHistory.data}
                    pagination={false}
                    footer={() => (
                        <>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignContent: 'center' }}>
                                <div>Tổng {activityHistory.total || 0} giao dịch</div>
                                <Pagination
                                    showSizeChanger
                                    pageSize={pageSize}
                                    onShowSizeChange={(_current, size) => setPageSize(size)}
                                    total={activityHistory.total}
                                    current={currentPage}
                                    onChange={activePage => setCurrentPage(activePage)}
                                />
                            </div>
                            <Divider />
                            <Descriptions title={`Tổng kết / ${activityHistory.data?.length} giao dịch`} items={[
                                {
                                    label: 'Tổng nạp tiền',
                                    children: formatNumber(activityHistory.data?.reduce((sum: any, value: any) => {
                                        if (value.type === 2) {
                                            sum += Number(value.credit || 0)
                                        }
                                        return sum
                                    }, 0)),
                                },
                                {
                                    label: 'Tổng thanh toán',
                                    children: formatNumber(activityHistory.data?.reduce((sum: any, value: any) => {
                                        if (value.type === 3) {
                                            sum += Number(value.debit || 0)
                                        }
                                        return sum
                                    }, 0)),
                                },
                            ]} />
                        </>
                    )}
                />
            </Card>
        </div>
    </div>
    );
};
